var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"nav nav-tabs"},_vm._l((_vm.tabs),function(item,index){return _c('router-link',{key:index,attrs:{"to":item.url},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var navigate = ref.navigate;
var isActive = ref.isActive;
return [_c('span',{staticClass:"navlink",class:isActive ? 'active' : '',attrs:{"href":href},on:{"click":navigate}},[_vm._v(_vm._s(item.name))])]}}],null,true)})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }